const degrees = [
  {
    school: 'Hack Reactor',
    degree: 'Javascript and Python Immersive',
    link: 'https://www.hackreactor.com/',
    year: 2022,
  },
  {
    school: 'S.A.F.E',
    degree: 'Certificate in Mortgage Origination',
    link: 'https://www.nmlsconsumeraccess.org/EntityDetails.aspx/INDIVIDUAL/2071131',
    year: 2020,
  },
  {
    school: 'Rio Salado College',
    degree: 'A.S. General Studies',
    link: 'https://www.riosalado.edu/',
    year: 2019,
  },
  {
    school: 'Eastern Arizona College',
    degree: 'Certified Nurses Assistant',
    link: 'https://www.eac.edu/',
    year: 2010,
  },
];

export default degrees;